import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { DEFAULT_LANGUAGE } from '../providers/globalDataProvider/globalDataProvider.provider';
import { useSeo } from '../hooks/useSEO';

const SEO = function ({
  description,
  title,
  keywords,
  lang,
  pathname,
  pageTitle,
}) {
  const {
    alternate,
    baseUrl,
    canonical,
    description: seoDescription,
    image,
    keywords: seoKeywords,
    title: seoTitle,
    imageType,
    imageWidth,
    imageHeight,
    twitterUsername,
    pageTitle: seoPageTitle,
  } = useSeo({
    description,
    title,
    pageTitle,
    keywords,
    pathname,
  });
  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={seoPageTitle}
      titleTemplate={seoTitle}
    >
      <link rel="canonical" href={canonical} />
      {alternate}
      <meta name="robots" content="all" />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      {image && <meta name="image" content={image} />}
      <meta property="og:url" content={baseUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:keywords" content={seoKeywords} />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:type" content={imageType} />}
      {image && <meta property="og:image:width" content={imageWidth} />}
      {image && <meta property="og:image:height" content={imageHeight} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

SEO.propTypes = {
  pageTitle: PropTypes.string,
  description: PropTypes.string,
  lang: PropTypes.string,
  pathname: PropTypes.string,
  keywords: PropTypes.string,
  title: PropTypes.string.isRequired,
};

SEO.defaultProps = {
  lang: DEFAULT_LANGUAGE,
  description: '',
  pathname: '',
  keywords: undefined,
  pageTitle: undefined,
};

export default SEO;
